// One public settings store, default-hidden until the server confirms visibility.
let siteSettings = {footerVisible:false, topicsVisible:false, ready:false};
const siteSettingsListeners = new Set();
function publishSiteSettings(values) {
  siteSettings = {...siteSettings, ...values};
  for (const listener of siteSettingsListeners) listener();
}
window.topicsEnabled = () => siteSettings.topicsVisible === true;
window.useSiteSettings = () => React.useSyncExternalStore(listener => {
  siteSettingsListeners.add(listener); return () => siteSettingsListeners.delete(listener);
}, () => siteSettings);
window.addEventListener("mayanos-site-settings", event => publishSiteSettings(event.detail));
window.siteSettingsReady = fetch("/bff/site-settings", {cache:"no-store"}).then(r => {
  if (!r.ok) throw Error("Settings unavailable"); return r.json();
}).then(data => publishSiteSettings({footerVisible:data.footerVisible === true,topicsVisible:data.topicsVisible === true,ready:true}))
.catch(() => publishSiteSettings({ready:true}));
